import React, { useEffect, useState, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { GET, httpOk } from 'helpers/api'
import { FilterBar, DeptSelect, getDateRange, mln, ABC_COLOR, ABC_CAT, XYZ_COLOR, XYZ_CAT, TA_CSS } from './tovarShared'

// ABC/XYZ hujayra ohanglari (boshqaruv strategiyasi)
const CELL_TONE = {
	AX: 'g', AY: 'g', BX: 'g',
	AZ: 'm', BY: 'm', CX: 'm',
	BZ: 'r', CY: 'r', CZ: 'r',
}
const TONE = {
	g: { bg: '#f0fdf4', bd: '#bbf7d0', color: '#15803d' },
	m: { bg: '#fffbeb', bd: '#fde68a', color: '#b45309' },
	r: { bg: '#fef2f2', bd: '#fecaca', color: '#b91c1c' },
}

function Badge({ v, color }) {
	return <span className="ta-badge" style={{ background: color }}>{v}</span>
}

function AbcXyz() {
	const { t } = useTranslation()
	const [data, setData] = useState({ items: [], abc: null, xyz: null, matrix: null, total: 0, count: 0, weeks: 0 })
	const [quick, setQuick] = useState('month')
	const [range, setRange] = useState(getDateRange('month'))
	const [custom, setCustom] = useState({ start: null, end: null })
	const [dept, setDept] = useState('')
	const [tab, setTab] = useState('abc')

	const load = useCallback(async (r, dp) => {
		const params = { start_date: r.start, end_date: r.end }
		if (dp) params.department = dp
		const res = await GET('/analytics/abc-xyz', params, { loader: true })
		if (httpOk(res)) setData(res.data)
	}, [])
	useEffect(() => { load(range, dept) }, [range, dept, load])

	function onQuick(id) { setQuick(id); setCustom({ start: null, end: null }); setRange(getDateRange(id)) }
	function onCustom(s, e) {
		setCustom({ start: s, end: e })
		if (s && e) { setQuick(''); const f = d => d.toISOString().slice(0, 10); setRange({ start: f(s), end: f(e) }) }
	}

	const pct = v => data.total > 0 ? Math.round(v / data.total * 100) : 0
	const abc = data.abc, xyz = data.xyz, mx = data.matrix

	return (
		<>
			<style>{TA_CSS}</style>
			<div className="ta">
				<div className="ta-head">
					<div>
						<h4>{t('abc_xyz_title')}</h4>
						<div className="ta-hint">{t('abc_xyz_hint')}</div>
					</div>
					<div className="ta-tools">
						<DeptSelect value={dept} onChange={setDept} t={t} />
						<FilterBar quick={quick} custom={custom} onQuick={onQuick} onCustom={onCustom} t={t} />
					</div>
				</div>

				{/* Taqsimlanish legendalari */}
				<div className="ta-legends">
					<div>
						<div className="ta-legend-t">{t('abc_dist')}</div>
						<div className="ta-legbar">
							<span style={{ flex: 80, background: ABC_COLOR.A }}>A · 0–80%</span>
							<span style={{ flex: 15, background: ABC_COLOR.B }}>B · 80–95%</span>
							<span style={{ flex: 8, background: ABC_COLOR.C }}>C · 95–100%</span>
						</div>
					</div>
					<div>
						<div className="ta-legend-t">{t('xyz_dist')} · {t('cv_label')} · {data.weeks} {t('week_short')}</div>
						<div className="ta-legbar">
							<span style={{ flex: 10, background: XYZ_COLOR.X }}>X · ≤10%</span>
							<span style={{ flex: 50, background: XYZ_COLOR.Y }}>Y · 10–60%</span>
							<span style={{ flex: 40, background: XYZ_COLOR.Z }}>Z · &gt;60%</span>
						</div>
					</div>
				</div>

				{/* Tablar */}
				<div className="ta-tabs">
					{['abc', 'xyz', 'matrix'].map(k => (
						<button key={k} className={'ta-tab' + (tab === k ? ' on' : '')} onClick={() => setTab(k)}>{t('tab_' + k)}</button>
					))}
				</div>

				{/* ABC tab */}
				{tab === 'abc' && abc &&
					<div className="ta-catrow">
						{['A', 'B', 'C'].map(k => {
							const c = ABC_CAT[k]
							return (
								<div className="ta-cat" key={k} style={{ background: c.bg, borderColor: c.bd, color: c.color }}>
									<div className="ta-cat-t">{t('category')} {k}</div>
									<div className="ta-cat-sub" style={{ color: c.color }}>{t(c.sub)}</div>
									<div className="ta-cat-v">{abc[k].count} <span style={{ fontSize: 14, fontWeight: 600 }}>{t('positions')}</span></div>
									<div className="ta-cat-s">{mln(abc[k].value)} · {pct(abc[k].value)}%</div>
								</div>
							)
						})}
					</div>}

				{/* XYZ tab */}
				{tab === 'xyz' && xyz &&
					<div className="ta-catrow">
						{['X', 'Y', 'Z'].map(k => {
							const c = XYZ_CAT[k]
							return (
								<div className="ta-cat" key={k} style={{ background: c.bg, borderColor: c.bd, color: c.color }}>
									<div className="ta-cat-t">{t('category')} {k}</div>
									<div className="ta-cat-sub" style={{ color: c.color }}>{t(c.sub)}</div>
									<div className="ta-cat-v">{xyz[k].count} <span style={{ fontSize: 14, fontWeight: 600 }}>{t('positions')}</span></div>
									<div className="ta-cat-s">{mln(xyz[k].value)} · {pct(xyz[k].value)}%</div>
								</div>
							)
						})}
					</div>}

				{/* ABC/XYZ matritsa */}
				{tab === 'matrix' && mx &&
					<div className="ta-matrix">
						<div className="ta-mx-h"></div>
						{['X', 'Y', 'Z'].map(x => <div className="ta-mx-h" key={x}>{x}</div>)}
						{['A', 'B', 'C'].map(a => (
							<React.Fragment key={a}>
								<div className="ta-mx-h">{a}</div>
								{['X', 'Y', 'Z'].map(x => {
									const tone = TONE[CELL_TONE[a + x]]
									return (
										<div className="ta-mx-c" key={x} style={{ background: tone.bg, borderColor: tone.bd, color: tone.color }}>
											<div className="ta-mx-v">{mx[a][x]}</div>
											<div className="ta-mx-l">{a}{x}</div>
										</div>
									)
								})}
							</React.Fragment>
						))}
					</div>}

				{/* Jadval */}
				<div className="ta-block">
					<div className="ta-block-h">
						<i className="uil-apps me-1" />{t('abc_xyz_title')}
						<span className="ta-pill" style={{ marginLeft: 8, background: '#f1f5f9', color: '#475569' }}>{data.count} {t('goods')}</span>
					</div>
					<div className="ta-scroll">
						<table className="ta-tbl">
							<thead>
								<tr>
									<th style={{ width: 36 }}>#</th>
									<th>{t('name')}</th>
									<th>{t('department')}</th>
									<th className="ta-num">{t('revenue_sum')}</th>
									<th className="text-center">{t('w_qty')}</th>
									<th className="text-center">{t('w_sales')}</th>
									<th className="text-center">{t('w_profit')}</th>
									<th className="text-center">XYZ</th>
									<th className="text-center">ABC-XYZ</th>
								</tr>
							</thead>
							<tbody>
								{data.items.map((r, i) => (
									<tr key={r.id}>
										<td className="ta-num" style={{ color: '#94a3b8' }}>{i + 1}</td>
										<td>
											<div className="fw-semibold">{r.name}</div>
											<div className="ta-sub">{r.category} · {r.cheques} {t('cheques')}</div>
										</td>
										<td style={{ color: '#64748b' }}>{r.dept}</td>
										<td className="ta-num fw-semibold">{mln(r.revenue)}</td>
										<td className="text-center"><Badge v={r.abc_qty} color={ABC_COLOR[r.abc_qty]} /></td>
										<td className="text-center"><Badge v={r.abc} color={ABC_COLOR[r.abc]} /></td>
										<td className="text-center"><Badge v={r.abc_profit} color={ABC_COLOR[r.abc_profit]} /></td>
										<td className="text-center">
											<Badge v={r.xyz} color={XYZ_COLOR[r.xyz] || '#94a3b8'} />
											{r.cv != null && <div className="ta-sub" style={{ textAlign: 'center' }}>{r.cv}%</div>}
										</td>
										<td className="text-center fw-bold" style={{ color: TONE[CELL_TONE[r.cell]] ? TONE[CELL_TONE[r.cell]].color : '#0f172a' }}>{r.cell}</td>
									</tr>
								))}
								{data.items.length === 0 && <tr><td colSpan={9} className="ta-empty">{t('no_data')}</td></tr>}
							</tbody>
						</table>
					</div>
				</div>
			</div>
		</>
	)
}

export default AbcXyz
